import { useCallback } from 'react';
import { leadContainer } from '../../di/container';
import type { SignUpLead } from '../../domain/entities/lead.entity';

/**
 * O registro do aceite, para os formulários. Dispara e esquece: sem `await`,
 * ele não atrasa nem derruba o cadastro (o repositório engole a falha).
 */
export function useLeadCapture() {
  const captureSignUp = useCallback((lead: SignUpLead) => {
    void leadContainer.repository.captureSignUp(lead);
  }, []);
  return { captureSignUp };
}
